/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Community Manager API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { CompanyRightAssignmentString } from '../../../../../../org/dataland/datalandfrontend/openApiClient/communitymanager/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/communitymanager/model';
/**
 * CompanyRightsControllerApi - axios parameter creator
 */
export const CompanyRightsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove a company right from a Dataland company.
         * @summary Delete a company right assignment.
         * @param {CompanyRightAssignmentString} companyRightAssignmentString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyRight: async (companyRightAssignmentString: CompanyRightAssignmentString, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyRightAssignmentString' is not null or undefined
            assertParamExists('deleteCompanyRight', 'companyRightAssignmentString', companyRightAssignmentString)
            const localVarPath = `/company-rights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyRightAssignmentString, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all rights assigned to a Dataland company, specified via its ID.
         * @summary Get company rights.
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyRights: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyRights', 'companyId', companyId)
            const localVarPath = `/company-rights/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a company right to a Dataland company, specified by its ID.
         * @summary Post a company right assignment.
         * @param {CompanyRightAssignmentString} companyRightAssignmentString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyRight: async (companyRightAssignmentString: CompanyRightAssignmentString, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyRightAssignmentString' is not null or undefined
            assertParamExists('postCompanyRight', 'companyRightAssignmentString', companyRightAssignmentString)
            const localVarPath = `/company-rights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyRightAssignmentString, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyRightsControllerApi - functional programming interface
 */
export const CompanyRightsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyRightsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove a company right from a Dataland company.
         * @summary Delete a company right assignment.
         * @param {CompanyRightAssignmentString} companyRightAssignmentString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompanyRight(companyRightAssignmentString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyRightsControllerApi.deleteCompanyRight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of all rights assigned to a Dataland company, specified via its ID.
         * @summary Get company rights.
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyRights(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyRights(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyRightsControllerApi.getCompanyRights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a company right to a Dataland company, specified by its ID.
         * @summary Post a company right assignment.
         * @param {CompanyRightAssignmentString} companyRightAssignmentString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyRightAssignmentString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyRight(companyRightAssignmentString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyRightsControllerApi.postCompanyRight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyRightsControllerApi - factory interface
 */
export const CompanyRightsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyRightsControllerApiFp(configuration)
    return {
        /**
         * Remove a company right from a Dataland company.
         * @summary Delete a company right assignment.
         * @param {CompanyRightAssignmentString} companyRightAssignmentString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCompanyRight(companyRightAssignmentString, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all rights assigned to a Dataland company, specified via its ID.
         * @summary Get company rights.
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyRights(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getCompanyRights(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a company right to a Dataland company, specified by its ID.
         * @summary Post a company right assignment.
         * @param {CompanyRightAssignmentString} companyRightAssignmentString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig): AxiosPromise<CompanyRightAssignmentString> {
            return localVarFp.postCompanyRight(companyRightAssignmentString, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyRightsControllerApi - interface
 */
export interface CompanyRightsControllerApiInterface {
    /**
     * Remove a company right from a Dataland company.
     * @summary Delete a company right assignment.
     * @param {CompanyRightAssignmentString} companyRightAssignmentString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get a list of all rights assigned to a Dataland company, specified via its ID.
     * @summary Get company rights.
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyRights(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * Assign a company right to a Dataland company, specified by its ID.
     * @summary Post a company right assignment.
     * @param {CompanyRightAssignmentString} companyRightAssignmentString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig): AxiosPromise<CompanyRightAssignmentString>;

}

/**
 * CompanyRightsControllerApi - object-oriented interface
 */
export class CompanyRightsControllerApi extends BaseAPI implements CompanyRightsControllerApiInterface {
    /**
     * Remove a company right from a Dataland company.
     * @summary Delete a company right assignment.
     * @param {CompanyRightAssignmentString} companyRightAssignmentString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig) {
        return CompanyRightsControllerApiFp(this.configuration).deleteCompanyRight(companyRightAssignmentString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all rights assigned to a Dataland company, specified via its ID.
     * @summary Get company rights.
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyRights(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyRightsControllerApiFp(this.configuration).getCompanyRights(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a company right to a Dataland company, specified by its ID.
     * @summary Post a company right assignment.
     * @param {CompanyRightAssignmentString} companyRightAssignmentString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCompanyRight(companyRightAssignmentString: CompanyRightAssignmentString, options?: RawAxiosRequestConfig) {
        return CompanyRightsControllerApiFp(this.configuration).postCompanyRight(companyRightAssignmentString, options).then((request) => request(this.axios, this.basePath));
    }
}

